import { render } from "./SliderItemSport.vue?vue&type=template&id=b050d01a"
import script from "./SliderItemSport.vue?vue&type=script&lang=js"
export * from "./SliderItemSport.vue?vue&type=script&lang=js"

import "./SliderItemSport.vue?vue&type=style&index=0&id=b050d01a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__